const siteUrl = "https://aviacioninsightrd.com";

export function getShareUrl(slug: string): string {
  return `${siteUrl}/articulo/${encodeURIComponent(slug)}`;
}